module.exports = __webpack_public_path__ + "img/print2.765114fb.svg";